'use client';

import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { TitleWrapperStyled as StyledTitleMenu } from './Header.styled';

import { NavLink } from './NavLink';
import { NavLinkDropDownMenu } from './NavLinkDropDownMenu';
import { AllWatchesNavLinkDropDownMenu } from './AllWatchesNavLinkDropDownMenu/AllWatchesNavLinkDropDownMenu';
import { BrandsNavLinkDropDownMenu } from './BrandsNavLinkDropDownMenu/BrandsNavLinkDropDownMenu';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import { reducerTypes } from '../../store/Product/types';
import { getSuggestionAction } from '../../store/Product/action';
import { sagaTypes } from '../../store/SelectedCurrency/types';

interface TitleMenuProps {
  messages: { header_items: { title: string; path: string; icon: string }[] };
}

export const TitleMenu: React.FC<TitleMenuProps> = ({ messages }) => {
  const [brandsNavLinkDropDownVisible, setBrandsNavLinkDropdownVisible] = useState(false);
  const [allWatchesDropdownVisible, setAllWatchesDropdownVisible] = useState(false);
  const [sellTradeDropdownVisible, setSellTradeDropdownVisible] = useState(false);
  const { initialFilters } = useAppSelector((st) => st.products);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch({ type: sagaTypes.GET_CURRENCIES, payload: null });
  }, [dispatch]);

  useEffect(() => {
    if (
      window.location.href.includes('all-watches') ||
      window.location.href.includes('new-arrivals') ||
      window.location.href.includes('collections')
    ) {
      return;
    }
    dispatch({ type: reducerTypes.GET_FILTERS, payload: initialFilters });
  }, [dispatch, initialFilters]);

  return (
    <StyledTitleMenu sx={{ minHeight: { lg: 40 } }}>
      {messages.header_items.map((item, index) => {
        switch (index) {
          case 1:
            return (
              <Box key={index} onMouseLeave={() => setBrandsNavLinkDropdownVisible(false)}>
                <NavLink
                  {...item}
                  onClick={(e) => {
                    setBrandsNavLinkDropdownVisible(true);
                  }}
                  onMouseOver={() => setBrandsNavLinkDropdownVisible(true)}
                  forHeader
                  marginBottom='0px'
                />
                <BrandsNavLinkDropDownMenu
                  brandsNavLinkDropDownVisible={brandsNavLinkDropDownVisible}
                  setBrandsNavLinkDropdownVisible={setBrandsNavLinkDropdownVisible}
                />
              </Box>
            );

          case 2:
            return (
              <Box key={index} onMouseLeave={() => setAllWatchesDropdownVisible(false)}>
                <NavLink
                  {...item}
                  path='/all-watches'
                  onClick={(e) => {
                    setAllWatchesDropdownVisible(true);
                    dispatch(getSuggestionAction({ columnName: '', value: '' }));
                    const resetFilters = initialFilters.map((filter) => ({
                      ...filter,
                      filters: filter.filters.map((f) => ({ ...f, checked: false })),
                    }));
                    dispatch({
                      type: reducerTypes.GET_INITIAL_FILTERS,
                      payload: resetFilters,
                    });
                    dispatch({ type: reducerTypes.GET_FILTERS, payload: resetFilters });
                  }}
                  onMouseOver={() => setAllWatchesDropdownVisible(true)}
                  forHeader
                  marginBottom='0px'
                />
                <AllWatchesNavLinkDropDownMenu
                  allWatchesDropdownVisible={allWatchesDropdownVisible}
                  setAllWatchesDropdownVisible={setAllWatchesDropdownVisible}
                />
              </Box>
            );

          case 3:
            return (
              <Box key={index} onMouseLeave={() => setSellTradeDropdownVisible(false)}>
                <NavLink
                  {...item}
                  onClick={(e) => {
                    setSellTradeDropdownVisible(true);
                  }}
                  onMouseOver={() => setSellTradeDropdownVisible(true)}
                  forHeader
                  marginBottom='0px'
                />
                <NavLinkDropDownMenu
                  sellTradeDropdownVisible={sellTradeDropdownVisible}
                  setSellTradeDropdownVisible={setSellTradeDropdownVisible}
                />
              </Box>
            );

          default:
            return <NavLink {...item} key={index} forHeader marginBottom='0px' />;
        }
      })}
    </StyledTitleMenu>
  );
};
